import React, { useEffect, useRef, useState } from "react";
import PageTitle from "../components/PageTitle";
import BarChart from "../components/dashbaord/BarChart";
import banner from "../assets/flowticker-images/banner-img.png";
import calendar from "../assets/img/dashboard/calendar.svg";
import { Link, useNavigate } from "react-router-dom";
import TaskList from "../components/dashbaord/TaskList";
import Api from "../api/api";
import LineChart from "../components/dashbaord/Linechart";
import Profile from "../components/login/Profile";
import defaultProfitabilityStrategies from "../assets/flowticker-images/default-profitability-strategies.png"
import defaultMetrices from "../assets/flowticker-images/defaultMetrices.jpg"
import { LiaAngleLeftSolid } from "react-icons/lia";
import FormBox from "../components/FormBox";
import { useMyContext } from "../context/MyContext";
import { Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import EnhancedDashboard from "../components/dashbaord/EnhancedDashboard";
import html2canvas from 'html2canvas';
import Spinner from "../components/common/Spinner";


const DynamicModal = React.memo(() => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [modal, setmodal] = useState(true);
  const closeModal = () => {
    setmodal(false);
    localStorage.clear();
    navigate("/")
  };

  const submitmodal = async () => {
    if (localStorage.getItem("TCVersionId") != undefined) {
      try {
        let params = {
          version_id: localStorage.getItem("TCVersionId")
        }
        let res = await Api.updateTC(params);
        setmodal(false);
        localStorage.setItem("TCAccepted", "Y");
        localStorage.setItem("TCVersionId", "");
        localStorage.setItem("TCData", "")
      } catch (error) {
        console.log(error);
      }
    } else {
      localStorage.clear();
      navigate("/")
    };
  };
  return (
    <div
      className={`login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${modal && localStorage.getItem("TCAccepted") === "N" ? "d-flex" : "d-none"
        }`}
    >
      <div className="login-otp-wrap- bg-white p-3 p-md-4 rounded-4" style={{
        maxWidth: "80%"
      }}>
        <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
          <button
            className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
            onClick={closeModal}
          >
            <LiaAngleLeftSolid />
          </button>
          <h4 className="mb-0">Terms and Conditions</h4>
        </div>
        <div
          ref={scrollRef}
          style={{
            maxHeight: "475px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="my-5">
            <div className="row">
              <div className="col">
                <div>
                  <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{localStorage.getItem("TCData")}</pre>
                </div>
                <Form className="mt-4" >
                  <input type="checkbox" value={agreed} onChange={(e) => setAgreed(e.target.checked)} /> I agree to the above terms & conditions
                </Form>
              </div>
            </div>
          </div>
        </div>
        {/* <button
          className="btn w-50 fs-14 mb-3 my-3 mt-3"
          style={{ marginTop: "50px" }}
          onClick={closeModal}
        >
          Reject
        </button> */}

        <button className="btn bg-primary w-100 fs-14"
          onClick={submitmodal}
          disabled={!agreed}
        >
          Accept
        </button>
      </div>
    </div>
  );
});

export default function Home() {
  const [metrics, setMatrics] = useState(null);
  const [profitS, setProfitS] = useState([]);
  const [profileShow, setProfileShow] = useState(false);
  const [loader, setLoader] = useState(true);
  // Individual loading states for progressive loading
  const [loadingMetrics, setLoadingMetrics] = useState(true);
  const [loadingPNL, setLoadingPNL] = useState(true);
  const [loadingStrategies, setLoadingStrategies] = useState(true);
  const [loadingActivities, setLoadingActivities] = useState(true);
  const [activities, setActivities] = useState([]);
  const [copyStrategyModal, setCopyStrategyModal] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [newStrategyName, setNewStrategyName] = useState("");
  const [isCopying, setIsCopying] = useState(false);

  const [labels, setLabels] = useState([]);
  const [datas, setDatas] = useState([]);
  const [cumulativeDatas, setCumulativeDatas] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const dashboardRef = useRef(null);

  const navigate = useNavigate();
  const [isLinechart, setIsLinechart] = useState(false);
  const [chartType, setChartType] = useState('daily'); // 'daily' for bar chart, 'cumulative' for line chart

  const handleSubscribeClick = (strategy) => {
    setSelectedStrategy(strategy);
    setNewStrategyName(`${strategy.strategy_name}_Copy`);
    setCopyStrategyModal(true);
  };

  const closeCopyStrategyModal = () => {
    setCopyStrategyModal(false);
    setSelectedStrategy(null);
    setNewStrategyName("");
    setIsCopying(false);
  };

  const handleCopyStrategy = async () => {
    if (!newStrategyName.trim()) {
      toast.error("Please enter a strategy name");
      return;
    }

    if (isCopying) {
      return; // Prevent multiple clicks
    }

    setIsCopying(true);

    try {
      // Call the API to copy the strategy
      const payload = {
        strategy_id: selectedStrategy.strategy_id,
        new_strategy_name: newStrategyName.trim()
      };
      
      const response = await Api.copyStrategy(payload);
      
      console.log("Copy strategy response:", response); // Debug log
      
      // Check if the response indicates success (either by message or success property)
      if (response.message || response.success) {
        toast.success(response.message || "Strategy copied successfully!");
        closeCopyStrategyModal();
        
        // Navigate to the strategies page after successful copy
        navigate("/strategies");
      } else {
        toast.error(response.message || "Error copying strategy");
        setIsCopying(false); // Reset loading state on error
      }
    } catch (error) {
      console.error("Error copying strategy:", error);
      toast.error(error.message || "Error copying strategy");
      setIsCopying(false); // Reset loading state on error
    }
  };

  const handleQuickAction = (action) => {
    switch (action) {
      case 'create-strategy':
        navigate('/create-strategies');
        break;
      case 'view-analytics':
        navigate('/analytics');
        break;
      case 'settings':
        navigate('/profile');
        break;
      case 'notifications':
        setShowNotifications(true);
        break;
      case 'export-data':
        handleExportData();
        break;
      case 'share':
        setShowShareModal(true);
        break;
      default:
        break;
    }
  };

  const handleExportData = () => {
    try {
      // Prepare data for export
      const exportData = [];
      
      // Add metrics data
      if (metrics) {
        exportData.push({
          'Metric': 'Total Profit',
          'Value': metrics.overall_pnl || 0
        });
        exportData.push({
          'Metric': 'Active Strategies',
          'Value': metrics.active_strategy_cnt || 0
        });
        exportData.push({
          'Metric': 'Win Rate (%)',
          'Value': metrics.win_pct || 0
        });
        exportData.push({
          'Metric': 'Trading Days',
          'Value': metrics.no_of_days_traded || 0
        });
        exportData.push({
          'Metric': 'Avg P&L per Day',
          'Value': metrics.avg_pnl || 0
        });
        exportData.push({
          'Metric': 'Risk Score',
          'Value': metrics.loss_pct || 0
        });
        exportData.push({ 'Metric': '', 'Value': '' }); // Empty row
      }

      // Add P&L data
      if (labels.length > 0 && datas.length > 0) {
        exportData.push({ 'Metric': 'Date', 'Value': 'Daily P&L' });
        labels.forEach((label, index) => {
          exportData.push({
            'Metric': label,
            'Value': datas[index] || 0
          });
        });
      }

      // Convert to CSV
      const headers = Object.keys(exportData[0]);
      const csvContent = [
        headers.join(','),
        ...exportData.map(row => 
          headers.map(header => {
            const value = row[header];
            // Escape commas and quotes in values
            if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
              return `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          }).join(',')
        )
      ].join('\n');

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `dashboard-export-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success('Data exported successfully!');
    } catch (error) {
      console.error('Error exporting data:', error);
      toast.error('Failed to export data');
    }
  };

  const captureDashboardSnapshot = async () => {
    try {
      // Check if dashboard is available
      if (!metrics || (!datas?.length && !profitS?.length)) {
        toast.error('Dashboard data not available. Please wait for the dashboard to load.');
        return null;
      }

      // Wait a bit to ensure the component is fully rendered
      await new Promise(resolve => setTimeout(resolve, 300));
      
      let elementToCapture = null;
      
      // Try to use ref first
      if (dashboardRef.current) {
        const snapshotContent = dashboardRef.current.querySelector('.snapshot-content');
        elementToCapture = snapshotContent || dashboardRef.current;
      }
      
      // Fallback: Try to find by class name
      if (!elementToCapture) {
        const snapshotContent = document.querySelector('.snapshot-content');
        const dashboardElement = document.querySelector('.enhanced-dashboard');
        elementToCapture = snapshotContent || dashboardElement;
      }
      
      if (!elementToCapture) {
        console.error('Dashboard element not found');
        console.log('Ref current:', dashboardRef.current);
        console.log('QuerySelector result:', document.querySelector('.enhanced-dashboard'));
        toast.error('Dashboard content not available. Please refresh the page and try again.');
        return null;
      }

      toast.info('Generating snapshot...', { autoClose: 2000 });
      
      // Capture the dashboard section
      const canvas = await html2canvas(elementToCapture, {
        backgroundColor: '#f8f9fa',
        scale: 2, // Higher quality
        logging: false,
        useCORS: true,
        allowTaint: false,
        windowWidth: elementToCapture.scrollWidth,
        windowHeight: elementToCapture.scrollHeight,
        scrollX: 0,
        scrollY: 0
      });

      // Convert canvas to blob
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png', 1.0);
      });
    } catch (error) {
      console.error('Error capturing snapshot:', error);
      toast.error('Failed to capture snapshot: ' + error.message);
      return null;
    }
  };

  const handleShare = async () => {
    try {
      const blob = await captureDashboardSnapshot();
      
      if (!blob) {
        return;
      }

      // Create a File object for sharing
      const file = new File([blob], `dashboard-snapshot-${new Date().toISOString().split('T')[0]}.png`, {
        type: 'image/png'
      });

      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        // Use Web Share API with file if available
        await navigator.share({
          title: 'Flowtickr Dashboard Snapshot',
          text: 'Check out my trading dashboard performance!',
          files: [file]
        });
        toast.success('Shared successfully!');
      } else {
        // Fallback: Copy image to clipboard
        try {
          await navigator.clipboard.write([
            new ClipboardItem({
              'image/png': blob
            })
          ]);
          toast.success('Dashboard snapshot copied to clipboard!');
        } catch (clipboardError) {
          // If clipboard API fails, download the image
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `dashboard-snapshot-${new Date().toISOString().split('T')[0]}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          toast.success('Dashboard snapshot downloaded!');
        }
      }
      setShowShareModal(false);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing:', error);
        toast.error('Failed to share snapshot');
      }
    }
  };

  const handleCopySnapshot = async () => {
    try {
      const blob = await captureDashboardSnapshot();
      
      if (!blob) {
        return;
      }

      try {
        await navigator.clipboard.write([
          new ClipboardItem({
            'image/png': blob
          })
        ]);
        toast.success('Snapshot copied to clipboard!');
        setShowShareModal(false);
      } catch (clipboardError) {
        // Fallback: Download the image
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `dashboard-snapshot-${new Date().toISOString().split('T')[0]}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        toast.success('Snapshot downloaded!');
        setShowShareModal(false);
      }
    } catch (error) {
      console.error('Error copying snapshot:', error);
      toast.error('Failed to copy snapshot');
    }
  };

  async function getPNLData() {
    try {
      setLoadingPNL(true);
      let res = await Api.pnlChart();
      
      // Filter out future dates - only include dates up to today
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day for comparison
      
      const filteredData = res?.data?.filter(item => {
        if (!item?.run_date) return false;
        const runDate = new Date(item.run_date);
        runDate.setHours(0, 0, 0, 0);
        return runDate <= today;
      }) || [];
      
      const labelsArray = filteredData.map(item => item?.run_date) || [];
      const datasArray = filteredData.map(item => parseFloat(item?.overall_pnl || 0)) || [];
      
      // Extract cumulative P&L, or calculate it if not provided
      const cumulativeArray = filteredData.map(item => parseFloat(item?.cumulative_pnl || 0)).length > 0 && filteredData[0]?.cumulative_pnl !== undefined
        ? filteredData.map(item => parseFloat(item?.cumulative_pnl || 0))
        : datasArray.reduce((acc, val, idx) => {
            const prev = idx === 0 ? 0 : acc[idx - 1];
            return [...acc, prev + val];
          }, []);
      
      setLabels(labelsArray);
      setDatas(datasArray);
      setCumulativeDatas(cumulativeArray);
      setIsLinechart(res?.data?.isLinechart ? res.data.isLinechart : false);
    } catch (error) {
      //alert("Error while fetching PNL chart data");
    } finally {
      setLoadingPNL(false);
    }
  }

  const [isTask, setIsTask] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTask(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Load all data independently - each API call updates its own state
    // This allows the dashboard to show immediately with progressive loading
    getDashboardMetrics();
    getPNLData();
    getProfitableStrategies();
    getActivities();
  }, []);

  async function getActivities() {
    try {
      setLoadingActivities(true);
      let res = await Api.dashboardActivities();
      console.log('Activities API response:', res);
      if (res?.data) {
        console.log('Setting activities:', res.data);
        setActivities(res.data);
      } else {
        console.log('No data in response, setting empty array');
        setActivities([]);
      }
    } catch (error) {
      console.error('Error fetching activities:', error);
      setActivities([]);
    } finally {
      setLoadingActivities(false);
    }
  }

  async function getDashboardMetrics() {
    try {
      setLoadingMetrics(true);
      let res = await Api.dashboardMetrics();
      setMatrics(res?.data[0]);
      setIsTask(true);
    } catch (error) {
      //alert("Error while fetching Dashboard Metrics");
    } finally {
      setLoadingMetrics(false);
    }
  }

  async function getProfitableStrategies() {
    try {
      setLoadingStrategies(true);
      let res = await Api.profitableStrategies();
      setProfitS(res?.data);
      //setLoader(!loader)
    } catch (error) {
      //alert("Error while fetching Profitable Strategies");
    } finally {
      setLoadingStrategies(false);
    }
  }

  async function getPNLData() {
    try {
      setLoadingPNL(true);
      let res = await Api.pnlChart();
      
      // Filter out future dates - only include dates up to today
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day for comparison
      
      const filteredData = res?.data?.filter(item => {
        if (!item?.run_date) return false;
        const runDate = new Date(item.run_date);
        runDate.setHours(0, 0, 0, 0);
        return runDate <= today;
      }) || [];
      
      const labelsArray = filteredData.map(item => item?.run_date) || [];
      const datasArray = filteredData.map(item => parseFloat(item?.overall_pnl || 0)) || [];
      
      // Extract cumulative P&L, or calculate it if not provided
      const cumulativeArray = filteredData.map(item => parseFloat(item?.cumulative_pnl || 0)).length > 0 && filteredData[0]?.cumulative_pnl !== undefined
        ? filteredData.map(item => parseFloat(item?.cumulative_pnl || 0))
        : datasArray.reduce((acc, val, idx) => {
            const prev = idx === 0 ? 0 : acc[idx - 1];
            return [...acc, prev + val];
          }, []);
      
      setLabels(labelsArray);
      setDatas(datasArray);
      setCumulativeDatas(cumulativeArray);
      setIsLinechart(res?.data?.isLinechart ? res.data.isLinechart : false);
    } catch (error) {
      //alert("Error while fetching PNL chart data");
    } finally {
      setLoadingPNL(false);
    }
  }

  return (
    <>
      <PageTitle title="Home" />
      <DynamicModal />
      
      {/* Enhanced Dashboard Layout - Show immediately with progressive loading */}
      <EnhancedDashboard 
        ref={dashboardRef}
        metrics={metrics}
        profitS={profitS}
        labels={labels}
        datas={datas}
        cumulativeDatas={cumulativeDatas}
        isLinechart={isLinechart}
        loadingMetrics={loadingMetrics}
        loadingPNL={loadingPNL}
        loadingStrategies={loadingStrategies}
        loadingActivities={loadingActivities}
        activities={activities}
        onActionClick={handleQuickAction}
      />

      {profileShow && (
        <Profile
          onClick={() => setProfileShow(false)}
          className={profileShow ? "d-flex" : "d-none"}
        />
      )}
      
      {/* Notifications Modal */}
      {showNotifications && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }} onClick={() => setShowNotifications(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
              <div className="modal-header" style={{ borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title fw-bold">Notifications</h5>
                <button type="button" className="btn-close" onClick={() => setShowNotifications(false)}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <div className="text-center py-4">
                  <div style={{ fontSize: '48px', color: '#6c757d', marginBottom: '16px' }}>🔔</div>
                  <p style={{ color: '#495057', margin: 0, fontSize: '16px' }}>No new notifications</p>
                  <small style={{ color: '#6c757d', fontSize: '14px' }}>You're all caught up!</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Share Modal */}
      {showShareModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }} onClick={() => setShowShareModal(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
              <div className="modal-header" style={{ borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title fw-bold">Share Dashboard</h5>
                <button type="button" className="btn-close" onClick={() => setShowShareModal(false)}></button>
              </div>
              <div className="modal-body">
                <p style={{ color: '#495057', marginBottom: '16px', fontSize: '15px' }}>
                  Create a snapshot of your dashboard metrics and charts to share
                </p>
                <div className="alert alert-info d-flex align-items-center gap-2 mb-3" style={{ fontSize: '14px', padding: '12px' }}>
                  <span>📸</span>
                  <span>This will capture your current dashboard metrics and performance chart as an image</span>
                </div>
                <div className="d-flex gap-2">
                  <button 
                    className="btn btn-primary flex-fill" 
                    onClick={handleCopySnapshot}
                    style={{ borderRadius: '8px' }}
                  >
                    📋 Copy Snapshot
                  </button>
                  <button 
                    className="btn btn-outline-primary flex-fill" 
                    onClick={handleShare}
                    style={{ borderRadius: '8px' }}
                  >
                    📤 Share Snapshot
                  </button>
                </div>
                <div className="mt-3">
                  <button 
                    className="btn btn-outline-secondary w-100" 
                    onClick={() => setShowShareModal(false)}
                    style={{ borderRadius: '8px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Copy Strategy Modal */}
      {copyStrategyModal && (
        <div className="login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 d-flex">
          <div className="login-otp-wrap bg-white p-3 p-md-4 rounded-4">
            <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
              <button
                className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
                onClick={closeCopyStrategyModal}
              >
                <LiaAngleLeftSolid />
              </button>
              <h4 className="mb-0">Copy Strategy</h4>
            </div>
            
            <div className="mb-3">
              <label className="text-dark py-2">Strategy Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter strategy name"
                value={newStrategyName}
                onChange={(e) => setNewStrategyName(e.target.value)}
              />
            </div>
            
            <div className="d-flex gap-2">
              <button
                className="btn w-50 fs-14 mb-3"
                onClick={closeCopyStrategyModal}
                disabled={isCopying}
              >
                Cancel
              </button>
              <button 
                className="btn bg-primary w-50 fs-14 mb-3" 
                onClick={handleCopyStrategy}
                disabled={isCopying}
              >
                {isCopying ? "Copying..." : "Copy"}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* {isTask && <TaskList onClick={() => setIsTask(false)} />} */}
    </>
  );
}
